import { render, staticRenderFns } from "./DeviceChooser.vue?vue&type=template&id=c0b4235e&scoped=true"
import script from "./DeviceChooser.vue?vue&type=script&lang=ts"
export * from "./DeviceChooser.vue?vue&type=script&lang=ts"
import style0 from "./DeviceChooser.vue?vue&type=style&index=0&id=c0b4235e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b4235e",
  null
  
)

export default component.exports